import React from "react";
import PropTypes from "prop-types";
import analytics from "web/script/analytics/analytics";
import { connect } from "react-redux";
import { openAppHeaderSearch } from "web/redux/ducks/app-header-search";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import withReduxProvider from "web/react/redux-provider";
import styles from "./search-button.css";

function mapDispatchToProps(dispatch) {
    return {
        openAppHeaderSearch: () => dispatch(openAppHeaderSearch()),
    };
}

export function SearchButton({ openAppHeaderSearch }) {
    function onSearchClick() {
        var searchBar = document.querySelector(".app-header-bar-burger");
        if (searchBar) {
            openAppHeaderSearch();
        }
        analytics.event("header", "clicked", "burger_menu_search_button_open");
    }

    return (
        <a id="searchButton" onClick={onSearchClick} className={styles.iconWrapper}>
            <SVGIcon name="search-button" />
        </a>
    );
}

export default withReduxProvider(connect(null, mapDispatchToProps)(SearchButton));

SearchButton.propTypes = {
    openAppHeaderSearch: PropTypes.func,
};
